<template>
<div class="chapter">
<div class="inner_page">
<div id="ack">
<p class="Chapter-Name-1">Acknowledgments</p>
<p class="Body-NI">I want to start by thanking my amazing husband for always encouraging me to follow my dreams, pushing me to believe in myself, and supporting my journey. I want to thank my kids, biological and bonus; if it wasn’t for them, I wouldn’t have the experience to write a parenting book. A <span class="CharOverride-7">huge</span> thanks to my publisher, Milli—thank you for seeing my potential and being my corner man. Finally, to my editing team, y’all make a girl look good.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?38c60cd8